/**
 * @generated SignedSource<<1eb40fc784c946997646853578be5acb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type readingHistoryPanelArticle$data = {
  readonly __typename: "Article";
  readonly application: {
    readonly entityUuid: string;
  } | null | undefined;
  readonly entityId: string;
  readonly entityUuid: string;
  readonly headline: string | null | undefined;
  readonly socialHeadline: string | null | undefined;
  readonly urlAlias: string;
  readonly " $fragmentType": "readingHistoryPanelArticle";
};
export type readingHistoryPanelArticle$key = {
  readonly " $data"?: readingHistoryPanelArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"readingHistoryPanelArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "readingHistoryPanelArticle"
};

(node as any).hash = "af787a050af248c5e8bd042565039780";

export default node;
